const shuffleArray = (array: {
    textBySyllables: string[];
    correctAnswer: string;
  }[]) => {
  const result = [...array];

  for (let i = result.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));

    [result[i], result[j]] = [result[j], result[i]];
  }

  return result;
};
export default shuffleArray;